import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player';
export default class Video{

    constructor(element) {
        this._wrapper = element;
        this.type = this._wrapper.getAttribute('data-type');
        this.src = this._wrapper.getAttribute('data-src');
        this.poster = this._wrapper.getAttribute('data-poster');
        
        this.bindEvents();
    }
    
    bindEvents(){
        if(this.type == 'youtube'){
            window.addEventListener('borlabs-cookie-consent-saved', () => {
                if(window.BorlabsCookie.Consents.hasConsent('youtube', 'external-media')){
                    this._wrapper.querySelector('.js-video-consent').remove();
                    VidstackPlayer.create({
                        target: this._wrapper,
                        src: this.src,
                        poster:this.poster,
                        layout: new VidstackPlayerLayout({
                            thumbnails: 'https://files.vidstack.io/sprite-fight/thumbnails.vtt',
                        }),
                    });
                }
            });
        }
    }
}